module.exports = __webpack_public_path__ + "img/av-mobile-hover.55b0a2d9.png";